import React, { useState, useEffect } from "react";
import PassengerFormTabs from "@/pages/user/forms/components/PassengerFormTabs";
import { validateField } from "@/pages/user/forms/utils/fieldValidators";
import {api} from "@/utils/api";

/**
 * FormRenderer Component
 
 *
 * @param {Object} config - Form configuration object containing sections/fields (resolveFormConfig) according to category and purpose-code
 * @param {Object} initialValues - Pre-filled values (e.g., from AI extraction)
 * @param {Function} onSubmit - Callback function when form is submitted
 */

// function FormRenderer({
//   config,
//   initialValues,
//   onSubmit,
//   onSectionSave,
//   nationality,
//   portOfEntry,
//   portOfExit,
//   previousNationalities,
//   otherNationalities,
//   country,
//   mode = "edit", // "edit" | "review" | "view"
//   uploadedDocuments = [], // ✅ Receive prop
//   applicationId = null, // ✅ Receive prop

// }) {

//   const [values, setValues] = useState({});
//   const [errors, setErrors] = useState({});

//   const dropdownData = {
//     nationality,
//     port_of_entry: portOfEntry,
//     port_of_exit: portOfExit,
//     previous_nationalities: previousNationalities,
//     other_passport_nationality: otherNationalities,
//     country_of_birth: country,
//   };

//   // Determine read-only state based on mode
//   const isReadOnly = mode === "review" || mode === "view";
//   const canNavigate = mode === "review" || mode === "view";


//   // useEffect(() => {
//   //   if (!config) return;

//   //   const defaults = {};

//   //   config.sections.forEach((section) => {
//   //     if (section.subTabs?.length) {
//   //       section.subTabs.forEach((subTab) => {
//   //         subTab.fields.forEach((field) => {
//   //           if (
//   //             field.default_value !== undefined &&
//   //             defaults[field.name] === undefined
//   //           ) {
//   //             defaults[field.name] = field.default_value;
//   //           }
//   //         });
//   //       });
//   //     }

//   //     if (section.fields?.length) {
//   //       section.fields.forEach((field) => {
//   //         if (
//   //           field.default_value !== undefined &&
//   //           defaults[field.name] === undefined
//   //         ) {
//   //           defaults[field.name] = field.default_value;
//   //         }
//   //       });
//   //     }
//   //   });

//   //   setValues((prev) => ({
//   //     ...defaults,
//   //     ...prev,
//   //     ...initialValues,
//   //   }));
//   // }, [config, initialValues]);


//   useEffect(() => {
//     if (!config || !config.sections) return; // ✅ Added safety check

//     const defaults = {};

//     config.sections.forEach((section) => {
//       if (section.subTabs?.length) {
//         section.subTabs.forEach((subTab) => {
//           // ✅ Added safety check for fields
//           if (subTab.fields?.length) {
//             subTab.fields.forEach((field) => {
//               if (
//                 field.default_value !== undefined &&
//                 defaults[field.name] === undefined
//               ) {
//                 defaults[field.name] = field.default_value;
//               }
//             });
//           }
//         });
//       }

//       if (section.fields?.length) {
//         section.fields.forEach((field) => {
//           if (
//             field.default_value !== undefined &&
//             defaults[field.name] === undefined
//           ) {
//             defaults[field.name] = field.default_value;
//           }
//         });
//       }
//     });

//     setValues((prev) => ({
//       ...defaults,
//       ...prev,
//       ...initialValues,
//     }));
//   }, [config, initialValues]);

//   // const handleChange = (name, value) => {
//   //   if (isReadOnly) return;

//   //   setValues((prev) => ({
//   //     ...prev,
//   //     [name]: value,
//   //   }));

//   //   setErrors((prev) => ({
//   //     ...prev,
//   //     [name]: undefined,
//   //   }));
//   // };

//   const handleChange = (name, value) => {
//     if (isReadOnly) return;

//     // Handle "Same as Present Address" checkbox
//     if (name === "same_as_present_address") {
//       if (value === true) {
//         // Copy present address fields to permanent address fields
//         setValues((prev) => ({
//           ...prev,
//           [name]: value,
//           permanent_address_street: prev.present_address_street || "",
//           permanent_address_city: prev.present_address_city || "",
//           permanent_address_state: prev.present_address_state || "",
//           permanent_address_zip: prev.present_address_zip || "",
//           permanent_address_country: prev.present_address_country || "",
//         }));
//       } else {
//         // Uncheck and clear permanent address fields
//         setValues((prev) => ({
//           ...prev,
//           [name]: value,
//           permanent_address_street: "",
//           permanent_address_city: "",
//           permanent_address_state: "",
//           permanent_address_zip: "",
//           permanent_address_country: "",
//         }));
//       }
//     } else {
//       // Normal field update
//       setValues((prev) => ({
//         ...prev,
//         [name]: value,
//       }));
//     }

//     setErrors((prev) => ({
//       ...prev,
//       [name]: undefined,
//     }));
//   };



//   // Called when user clicks "Next" in a section (PROGRESSIVE SAVE)
//   const handleSectionNext = () => {
//     if (onSectionSave && mode === "edit") {
//       onSectionSave(values); // Save to API
//     }
//   };


//   // const getAllFields = () => {
//   //   const allFields = [];

//   //       // ✅ Added safety check
//   //   if (!config || !config.sections) return allFields;

//   //   config.sections.forEach((section) => {

//   //     // ✅ Skip custom renderer sections without fields
//   //     if (section.useCustomRenderer && (!section.fields || section.fields.length === 0)) {
//   //       return;
//   //     }

//   //     if (section.subTabs?.length) {
//   //       section.subTabs.forEach((subTab) => {
//   //         allFields.push(...subTab.fields);
//   //       });
//   //     }

//   //     if (section.fields?.length) {
//   //       allFields.push(...section.fields);
//   //     }
//   //   });

//   //   return allFields;
//   // };

//   const getAllFields = () => {
//     const allFields = [];

//     // ✅ Added safety check
//     if (!config || !config.sections) return allFields;

//     config.sections.forEach((section) => {
//       // ✅ Skip custom renderer sections without fields
//       if (section.useCustomRenderer && (!section.fields || section.fields.length === 0)) {
//         return;
//       }

//       if (section.subTabs?.length) {
//         section.subTabs.forEach((subTab) => {
//           // ✅ Added safety check for fields
//           if (subTab.fields?.length) {
//             allFields.push(...subTab.fields);
//           }
//         });
//       }

//       if (section.fields?.length) {
//         allFields.push(...section.fields);
//       }
//     });

//     return allFields;
//   };

//   const validate = () => {
//     if (isReadOnly) return true;

//     const newErrors = {};
//     const allFields = getAllFields();

//     allFields.forEach((field) => {
//       const validations = [];

//       if (field.required) {
//         validations.push("required");
//       }

//       if (field.validations?.length) {
//         validations.push(...field.validations);
//       }

//       if (validations.length > 0) {
//         const fieldWithValidations = {
//           ...field,
//           validations,
//         };

//         const error = validateField(values[field.name], fieldWithValidations);

//         if (error) {
//           newErrors[field.name] = error;
//         }
//       }
//     });

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = () => {
//     if (!validate()) return;
//     onSubmit(values);
//   };


//   // ✅ Early return if no config
//   if (!config) {
//     return <p className="text-gray-500">No form configuration available.</p>;
//   }



//   return (
//     <div className="space-y-8">

//       <PassengerFormTabs
//         config={config}
//         values={values}
//         errors={errors}
//         onChange={handleChange}
//         onSectionNext={handleSectionNext}
//         dropdownData={dropdownData}
//         readOnly={isReadOnly}
//         allowNavigation={canNavigate}
//         mode={mode}
//         uploadedDocuments={uploadedDocuments} // ✅ Pass through
//         applicationId={applicationId} // ✅ Pass through
//       />

//       {/* Submit button - only in edit mode */}
//       {mode === "edit" && (
//         <div className="flex justify-end">
//           <button
//             type="button"
//             onClick={handleSubmit}
//             className="px-6 py-3 rounded-xl bg-blue-600 text-white font-semibold hover:bg-blue-700"
//           >
//             Continue to Review
//           </button>
//         </div>
//       )}
//     </div>
//   );
// }




function FormRenderer({
  config,
  initialValues,
  onSubmit,
  onSectionSave,
  nationality,
  portOfEntry,
  portOfExit,
  previousNationalities,
  otherNationalities,
  country,
  mode = "edit", // "edit" | "review" | "view"
  uploadedDocuments = [], // ✅ Receive prop
  applicationId = null, // ✅ Receive prop

}) {

  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [saarcVisits, setSaarcVisits] = useState([
    { id: 1, saarc_country: "", saarc_year: "", no_of_visits: "" }
  ]);

   // ✅ ADD: State for additional info rounds
  const [additionalInfoRounds, setAdditionalInfoRounds] = useState([]);

  const dropdownData = {
    nationality,
    port_of_entry: portOfEntry,
    port_of_exit: portOfExit,
    previous_nationalities: previousNationalities,
    other_passport_nationality: otherNationalities,
    country_of_birth: country,
  };

  // Determine read-only state based on mode
  const isReadOnly = mode === "review" || mode === "view";
  const canNavigate = mode === "review" || mode === "view";

  // ✅ ADD: Fetch additional info rounds
  useEffect(() => {
    if (applicationId) {
      fetchAdditionalInfoRounds();
    }
  }, [applicationId]);

  const fetchAdditionalInfoRounds = async () => {
    try {
      const res = await api.userGetAdditionalInfoRounds(applicationId);
      const list = Array.isArray(res.data?.rounds) ? res.data.rounds : [];
      setAdditionalInfoRounds(list);
    } catch (e) {
      console.error("Error fetching additional info rounds:", e);
      setAdditionalInfoRounds([]);
    }
  };

  useEffect(() => {
    if (!config || !config.sections) return;

    const defaults = {};

    config.sections.forEach((section) => {
      if (section.subTabs?.length) {
        section.subTabs.forEach((subTab) => {
          // ✅ Added safety check for fields
          if (subTab.fields?.length) {
            subTab.fields.forEach((field) => {
              if (
                field.default_value !== undefined &&
                defaults[field.name] === undefined
              ) {
                defaults[field.name] = field.default_value;
              }
            });
          }
        });
      }

      if (section.fields?.length) {
        section.fields.forEach((field) => {
          if (
            field.default_value !== undefined &&
            defaults[field.name] === undefined
          ) {
            defaults[field.name] = field.default_value;
          }
        });
      }
    });

    setValues((prev) => ({
      ...defaults,
      ...prev,
      ...initialValues,
    }));
  }, [config, initialValues]);



  const handleChange = (name, value) => {
    if (isReadOnly) return;

    // Handle "Same as Present Address" checkbox
    if (name === "same_as_present_address") {
      if (value === true) {
        // Copy present address fields to permanent address fields
        setValues((prev) => ({
          ...prev,
          [name]: value,
          permanent_street: prev.present_address_street || "",
          permanent_city: prev.present_address_city || "",
          permanent_state: prev.present_address_state || "",
         
        }));
      } else {
        // Uncheck and clear permanent address fields
        setValues((prev) => ({
          ...prev,
          [name]: value,
          permanent_street: "",
          permanent_city: "",
          permanent_state: "",
          
        }));
      }
    } else {
      // Normal field update
      setValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    setErrors((prev) => ({
      ...prev,
      [name]: undefined,
    }));
  };

  // Handle adding new SAARC visit entry
  const handleAddSaarcVisit = () => {
    setSaarcVisits((prev) => [
      ...prev,
      { id: Date.now(), saarc_country: "", saarc_year: "", no_of_visits: "" }
    ]);
  };

  // Handle removing SAARC visit entry
  const handleRemoveSaarcVisit = (id) => {
    if (saarcVisits.length === 1) return; // Keep at least one entry
    setSaarcVisits((prev) => prev.filter((visit) => visit.id !== id));
  };

  // Handle SAARC visit field change
  const handleSaarcVisitChange = (id, fieldName, value) => {
    setSaarcVisits((prev) =>
      prev.map((visit) =>
        visit.id === id ? { ...visit, [fieldName]: value } : visit
      )
    );
  };


  // Called when user clicks "Next" in a section (PROGRESSIVE SAVE)
  const handleSectionNext = () => {
    if (onSectionSave && mode === "edit") {
      onSectionSave(values); // Save to API
    }
  };

   // Update values when saarcVisits changes
  useEffect(() => {
    setValues((prev) => ({
      ...prev,
      saarc_visits: saarcVisits,
    }));
  }, [saarcVisits]);



  const getAllFields = () => {
    const allFields = [];

    // ✅ Added safety check
    if (!config || !config.sections) return allFields;

    config.sections.forEach((section) => {
      // ✅ Skip custom renderer sections without fields
      if (section.useCustomRenderer && (!section.fields || section.fields.length === 0)) {
        return;
      }

      if (section.subTabs?.length) {
        section.subTabs.forEach((subTab) => {
          // ✅ Added safety check for fields
          if (subTab.fields?.length) {
            allFields.push(...subTab.fields);
          }
        });
      }

      if (section.fields?.length) {
        allFields.push(...section.fields);
      }
    });

    return allFields;
  };

  const validate = () => {
    if (isReadOnly) return true;

    const newErrors = {};
    const allFields = getAllFields();

    allFields.forEach((field) => {
      const validations = [];

      if (field.required) {
        validations.push("required");
      }

      if (field.validations?.length) {
        validations.push(...field.validations);
      }

      if (validations.length > 0) {
        const fieldWithValidations = {
          ...field,
          validations,
        };

        const error = validateField(values[field.name], fieldWithValidations);

        if (error) {
          newErrors[field.name] = error;
        }
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;
    onSubmit(values);
  };


  // ✅ Early return if no config
  if (!config) {
    return <p className="text-gray-500">No form configuration available.</p>;
  }



  return (
    <div className="space-y-8">

      <PassengerFormTabs
        config={config}
        values={values}
        errors={errors}
        onChange={handleChange}
        onSectionNext={handleSectionNext}
        dropdownData={dropdownData}
        readOnly={isReadOnly}
        allowNavigation={canNavigate}
        mode={mode}
        uploadedDocuments={uploadedDocuments} // ✅ Pass through
        applicationId={applicationId} // ✅ Pass through

        // Pass SAARC visit handlers
        saarcVisits={saarcVisits}
        onAddSaarcVisit={handleAddSaarcVisit}
        onRemoveSaarcVisit={handleRemoveSaarcVisit}
        onSaarcVisitChange={handleSaarcVisitChange}

        // ✅ Pass additional info rounds
        additionalInfoRounds={additionalInfoRounds}
        onAdditionalInfoUpdate={fetchAdditionalInfoRounds} // ✅ Refresh callback
      />

      {/* Submit button - only in edit mode */}
      {mode === "edit" && (
        <div className="flex justify-end">
          <button
            type="button"
            onClick={handleSubmit}
            className="px-6 py-3 rounded-xl bg-blue-600 text-white font-semibold hover:bg-blue-700"
          >
            Continue to Review
          </button>
        </div>
      )}
    </div>
  );
}

export default FormRenderer;

